import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  ListProps,
  SelectInput,
} from "react-admin";
import TypeField from "../../components/TypeField";
import StatusField from "../../components/StatusField";
import CustomDateField from "../../components/CustomDateField";
import { statusList } from "./const";
import CustomPagination from "../../components/CustomPagination";
import ListWrapper from "../../components/ListWrapper";

const EmailLogFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const EmailLogList = (props: ListProps) => {
  const breadcrumb = [{ link: "/emailSendingLogs", title: "Email Logs" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Email Logs"
        isNotHaveSchoolFilter
        denseMode
        exporter={false}
        filters={<EmailLogFilter />}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        perPage={50}
        {...props}
        pagination={<CustomPagination />}
      >
        <Datagrid rowClick={null}>
          <TextField source="id" />
          <TextField source="email" label="Email" />
          <TypeField
            source="emailType"
            type="emailSendingLog_Type"
            label="Email Type"
          />
          <TextField source="log" emptyText="-" />
          <StatusField source="status" />
          <CustomDateField source="createdAt" isDateTime />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default EmailLogList;
